import dayjs from 'utils/dayjs-timezone';
export const filterDates = (dates, selectedDate, timezone) => {
    return dates.filter(date => dayjs(date.starts)
        .tz(timezone)
        .isSame(dayjs(selectedDate).tz(timezone), 'date'));
};
